export enum RiskLevel {
  INFO = "INFO",
  WARNING = "WARN",
  ALERT = "ALERT",
}
